import React from 'react'
import { AlertCircle, CheckCircle, Info, AlertTriangle, X } from 'lucide-react'
import { cn } from '../../utils/cn'

export interface AlertProps {
 type?: 'success' | 'error' | 'warning' | 'info'
 title?: string
 children: React.ReactNode
 onClose?: () => void
 className?: string
}

const Alert: React.FC<AlertProps> = ({
 type = 'info',
 title,
 children,
 onClose,
 className
}) => {
 const typeConfig = {
 success: {
 icon: CheckCircle,
 bgColor: 'bg-green-50 dark:bg-green-900/20',
 borderColor: 'border-green-200 dark:border-green-800',
 iconColor: 'text-green-600 dark:text-green-400',
 titleColor: 'text-green-800 dark:text-green-200',
 textColor: 'text-green-700 dark:text-green-300'
 },
 error: {
 icon: AlertCircle,
 bgColor: 'bg-red-50 dark:bg-red-900/20',
 borderColor: 'border-red-200 dark:border-red-800',
 iconColor: 'text-red-600 dark:text-red-400',
 titleColor: 'text-red-800 dark:text-red-200',
 textColor: 'text-red-700 dark:text-red-300'
 },
 warning: {
 icon: AlertTriangle,
 bgColor: 'bg-yellow-50 dark:bg-yellow-900/20',
 borderColor: 'border-yellow-200 dark:border-yellow-800',
 iconColor: 'text-yellow-600 dark:text-yellow-400',
 titleColor: 'text-yellow-800 dark:text-yellow-200',
 textColor: 'text-yellow-700 dark:text-yellow-300'
 },
 info: {
 icon: Info,
 bgColor: 'bg-blue-50 dark:bg-blue-900/20',
 borderColor: 'border-blue-200 dark:border-blue-800',
 iconColor: 'text-blue-600 dark:text-blue-400',
 titleColor: 'text-blue-800 dark:text-blue-200',
 textColor: 'text-blue-700 dark:text-blue-300'
 }
 }

 const config = typeConfig[type]
 const Icon = config.icon

 return (
 <div className={cn(
 'rounded-lg border p-4',
 config.bgColor,
 config.borderColor,
 className
 )}>
 <div className="flex items-start">
 <div className="flex-shrink-0">
 <Icon className={cn('h-5 w-5', config.iconColor)} />
 </div>
 <div className="ml-3 flex-1">
 {title && (
 <h3 className={cn('text-sm font-medium mb-1', config.titleColor)}>
 {title}
 </h3>
 )}
 <div className={cn('text-sm', config.textColor)}>
 {children}
 </div>
 </div>
 {onClose && (
 <div className="ml-auto pl-3">
 <div className="-mx-1.5 -my-1.5">
 <button
 type="button"
 onClick={onClose}
 className={cn(
 'inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2',
 config.iconColor,
 'hover:bg-opacity-20 focus:ring-offset-gray-50 dark:focus:ring-offset-gray-900'
 )}
 >
 <span className="sr-only">Fechar</span>
 <X className="h-4 w-4" />
 </button>
 </div>
 </div>
 )}
 </div>
 </div>
 )
}

export default Alert
